const puzzleData = [
    [],
    [
        "Photo Identities",
        "Matching The Key",
        "Picking The Lock"
    ],
    [
        "Check-In Sheet",
        "The Cloakroom Code",
        "Time Of Theft"
    ],
    [
        "Unlocking The Desk",
        "The Painting",
        "Unlocking the Safe",
        "Decoding The Thumb",
        "Decoding The Index Finger",
        "Decoding The Middle Finger",
        "Decoding The Fourth Finger",
        "Decoding The Fifth Finger"
    ], 
    [
        "The Coded Letter",
        "Jack's Game",
        "The Temperature",
        "The Time",
        "The Colour Bars"
    ],
    [
        "The Blueprint Puzzle",
        "People's Locations",
        "The Route Code",
        "Hideout Locations",
        "The Switches",
        "The Briefcase"
    ],
    [],
    []
]

export default puzzleData